import React from "react";
import startImg from "../../../../assets/images/item-background/start.png";
import dotImg from "../../../../assets/images/item-background/dot.png"
import img03 from  "../../../../assets/images/bg-section/image-03.png"
import img04 from "../../../../assets/images/bg-section/VR.jpg"
import { listItems2 } from "../../../../data/features";

export default function Features2() {
  return (
    <div className="wg-create-design style-1">
      <img
        className="item1 block-star"
        src={startImg}
        width={100}
        height={100}
        alt=""
      />
      <div className="item2 block-blur-1" />
      <div className="item3 block-blur-2" />
      <div className="item4 block-blur-3" />
      <div className="item5 block-blur-4" />
      <img
        className="item6"
        src={dotImg}
        width={463}
        height={300}
        alt=""
      />
      <div className="section-container">
        <div className="row">
          <div className="col-lg-5 ">
            <div className="content">
              <div className="heading-section wow fadeInUp">
                <h6>Empower Your Learning Journey</h6>
                <div className="main-title">
                  Flexible and Intuitive <br /> Learning{" "}
                  <span className="animation-text">Experience</span>
                </div>
              </div>
              <p className="">
                Avaxia Training Center offers an online platform designed to help you easily navigate through your educational journey. 
                With accessible resources and personalized support, you'll have everything you need to succeed.
              </p>
              <ul className="list-item">
                {listItems2.map((elm, i) => (
                  <li key={i}>
                    <i className="icon-check" />
                    {elm.text}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-lg-7 ">
            <div className="image">
              <img
                className="img-01"
                src={img03}
                alt=""
                width={640}
                height={540}
              />
              <img
                className="img-02"
                src={img04}
                alt=""
                width={345}
                height={345}
              />
              <img
                className="img-03"
                src={dotImg}
                alt=""
                width={463}
                height={300}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}